import HttpService from "./htttp.service";

class SheetsService {
  getSheets = async (query, cancelToken) => {
    const endpoint = "sheets";
    return await HttpService.get(endpoint, query, cancelToken);
  };
  getSheet = async (sheetId, query, cancelToken) => {
    const endpoint = "sheets/" + sheetId;
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createSheet = async (payload) => {
    const endpoint = "sheets";
    return await HttpService.post(endpoint, payload);
  };

  removeSheet = async (id) => {
    const endpoint = "sheets/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateSheet = async (id, payload) => {
    const endpoint = "sheets/" + id;
    return await HttpService.put(endpoint, payload);
  };

  addEntityItem = async (id, payload) => {
    const endpoint = "sheets/" + id + "/entityItems";
    return await HttpService.post(endpoint, payload);
  };

  answerSheet = async (
    id,
    sheetTemplateEntityElementId,
    sheetTemplateSheetPropertyId,
    payload,
  ) => {
    const endpoint = `sheets/${id}/answer/${sheetTemplateEntityElementId}/${sheetTemplateSheetPropertyId}`;
    return await HttpService.post(endpoint, payload);
  };

  answerSheetWithFiles = async (
    id,
    sheetTemplateEntityElementId,
    sheetTemplateSheetPropertyId,
    files,
    body,
  ) => {
    const endpoint = `sheets/${id}/answer/${sheetTemplateEntityElementId}/${sheetTemplateSheetPropertyId}`;
    return await HttpService.uploadFilesWithData(endpoint, files, body, "post");
  };
}

export default new SheetsService();
